/**
 * アイコン選択方法ステップ
 */
import { btnDelay } from "common/utils";
import I18n from "features/shared/i18n";
import { CreatePlayerState, PlayerIconMethod, PlayerWizardStep } from "../types";

interface PlayerIconMethodStepProps {
  state: CreatePlayerState;
  updateState: (updates: Partial<CreatePlayerState>) => void;
  goToStep: (step: PlayerWizardStep) => void;
  /** 狭い画面向け表示（カードを縦1列に並べる） */
  narrow?: boolean;
}

export const PlayerIconMethodStep = ({
  updateState,
  goToStep,
  narrow = false,
}: PlayerIconMethodStepProps) => {
  const handleSelectPreset = () => {
    btnDelay(() => {
      updateState({ iconMethod: PlayerIconMethod.PRESET, icon: "" });
      goToStep(PlayerWizardStep.PRESET_ICON);
    });
  };

  const handleSelectUpload = () => {
    btnDelay(() => {
      updateState({ iconMethod: PlayerIconMethod.UPLOAD, icon: "" });
      goToStep(PlayerWizardStep.UPLOAD_ICON);
    });
  };

  const handleSelectProfileAI = () => {
    btnDelay(() => {
      updateState({ iconMethod: PlayerIconMethod.PROFILE_AI, icon: "" });
      goToStep(PlayerWizardStep.PROFILE_AI);
    });
  };

  // 狭い画面ではアイコン+テキスト横並びの横長ボタン、通常は従来の正方形カード
  const cardClass = narrow
    ? "flex-row-el items-center justify-center gap-3 w-full py-5 rounded-[8px] cursor-pointer select-none"
    : "flex-col-el items-center justify-center w-[200px] h-[200px] rounded-[4px] cursor-pointer select-none";
  const cardIconClass = narrow
    ? "material-symbols-outlined !text-4xl text-white"
    : "material-symbols-outlined !text-5xl text-white mb-3";
  const cardLabelClass = narrow
    ? "text-body text-[18px] text-white"
    : "text-body text-[18px] text-white text-center whitespace-pre-line";

  return (
    <div className="flex-col-el flex-center w-full min-h-full py-8">
      {/* タイトル */}
      <div className="flex-col-el flex-center mb-8">
        <p className="text-body text-textcolor-black text-[24px] text-center">
          {I18n.t("MSG_ICON_SELECT_TITLE_BY_PARENT")}
        </p>
      </div>

      {/* 選択カード - 3択（狭い画面では横長ボタンの縦1列） */}
      <div
        className={
          narrow ? "flex-col-el items-stretch gap-6 w-full" : "flex-row-el flex-center gap-6"
        }
      >
        {/* プリセットから選ぶ */}
        <div onClick={handleSelectPreset} className={`${cardClass} bg-green-100`}>
          <span className={cardIconClass}>grid_view</span>
          <p className={cardLabelClass}>{I18n.t("MSG_ICON_SELECT_SYSTEM_BY_PARENT")}</p>
        </div>

        {/* アップロード */}
        <div onClick={handleSelectUpload} className={`${cardClass} bg-orange-100`}>
          <span className={cardIconClass}>upload</span>
          <p className={cardLabelClass}>{I18n.t("MSG_ICON_SELECT_UPLOAD_BY_PARENT")}</p>
        </div>

        {/* プロフィールから作る */}
        <div onClick={handleSelectProfileAI} className={`${cardClass} bg-blue-100`}>
          <span className={narrow ? cardIconClass : `${cardIconClass} mt-8`}>auto_awesome</span>
          <p className={cardLabelClass}>{I18n.t("MSG_ICON_SELECT_PROFILE_AI_BY_PARENT")}</p>
        </div>
      </div>
    </div>
  );
};
